// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"196":"1ecf8e9a","273":"1ecf8e9a","352":"da63097a","479":"bdef7ac0","539":"f134bfc2","595":"2fb8b6e2","640":"69425442"}[chunkId] + ".chunk.css";
};